import { isHeicImage } from "@redotech/images/heic";
import heic2any from "heic2any";

export async function convertHeicToJpeg(file: File): Promise<File> {
  const isHeic = isHeicImage(file.name, file.type);

  if (!isHeic) {
    return file;
  }

  try {
    const convertedBlob = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.9,
    });

    const blob = Array.isArray(convertedBlob)
      ? convertedBlob[0]
      : convertedBlob;

    const newFileName = file.name
      .replace(/\.heic$/i, ".jpg")
      .replace(/\.heif$/i, ".jpg");

    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    return new File([blob], newFileName, {
      type: "image/jpeg",
      lastModified: file.lastModified,
    });
  } catch (error) {
    throw new Error(
      "Failed to convert HEIC image. Please try converting the image to JPEG before uploading.",
    );
  }
}
